import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-coordinator-video-container',
  templateUrl: './coordinator-video-container.component.html',
  styleUrls: ['./coordinator-video-container.component.css']
})
export class CoordinatorVideoContainerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
}
